<template>
  <hic-dialog :title="title" :visible="visible" @close="cancel" width="60%" top="10vh">
    <el-row style="padding: 0 2rem">
      <el-row>
        <el-row type="flex" justify="space-between" class="ztitle">
          基本信息
        </el-row>
        <el-descriptions :column="3">
          <el-descriptions-item label="姓名">{{ entity.patientName }}</el-descriptions-item>
          <el-descriptions-item label="性别">{{ entity.patientGender | dictText('Gender') }}</el-descriptions-item>
          <el-descriptions-item label="住院科室">{{ entity.deptCode | dictText('Dept') }}</el-descriptions-item>
          <el-descriptions-item label="床位号">{{ entity.bedNo }}</el-descriptions-item>
          <el-descriptions-item label="住院号">{{ entity.ipNo }}</el-descriptions-item>
          <el-descriptions-item label="主要诊断">{{ entity.diagnosisName }}</el-descriptions-item>
        </el-descriptions>
      </el-row>
      <el-row type="flex" justify="space-between" class="ztitle">
        会诊信息
      </el-row>
      <el-descriptions title="">
        <el-descriptions-item label="会诊类型">{{ detailValue.type | dictText('ConsultationType') }}</el-descriptions-item>
        <el-descriptions-item label="预约会诊时间">{{ detailValue.appDate }}</el-descriptions-item>
        <el-descriptions-item label="病情及诊疗情况">{{ detailValue.situation }}</el-descriptions-item>
        <el-descriptions-item label="会诊目的">{{ detailValue.purpose }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ detailValue.memo }}</el-descriptions-item>
        <el-descriptions-item label="申请科室">{{ detailValue.targetDeptCode  | dictText('Dept') }}</el-descriptions-item>
        <el-descriptions-item label="申请人">{{ detailValue.doctorName }}</el-descriptions-item>
        <el-descriptions-item label="申请时间">{{ detailValue.appDate }}</el-descriptions-item>
      </el-descriptions>
      <el-row type="flex" v-if="detailValue.state == '已会诊'" justify="space-between" class="ztitle">
        接受信息
      </el-row>
      <el-descriptions v-if="detailValue.state == '已会诊'" title="">
        <el-descriptions-item label="会诊意见">{{ detailValue.opinions }}</el-descriptions-item>
        <el-descriptions-item label="会诊科室">{{ detailValue.dept }}</el-descriptions-item>
        <el-descriptions-item label="会诊医师">{{ detailValue.doctorCode }}</el-descriptions-item>
        <el-descriptions-item label="会诊时间">{{ detailValue.execDate }}</el-descriptions-item>
      </el-descriptions>
      <el-collapse v-if="detailValue.state == '已接受'" value="1">
        <el-collapse-item title="接受信息" name="1">
          <el-form class="left top-pad" ref="info" :rules="rules" :inline="true" :model="detailValue"
            label-width="6rem">
            <el-row>
              <el-col :span="24">
                <el-form-item label="会诊意见" prop="opinions">
                  <el-input type="textarea" style="width:48rem" :rows="2" placeholder="请输入会诊意见"
                    v-model="detailValue.opinions"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="会诊科室" prop="dept">
                  <hic-dept-selector v-model="detailValue.dept" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="会诊医师" prop="consultationDoctorCode">
                  <el-input type="text" maxlength="6" v-model="detailValue.consultationDoctorCode" placeholder="请输入医师名称" size="small"
                    clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="会诊时间" prop="execDate">
                  <el-date-picker size="small" v-model="detailValue.execDate" type="date"
                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择会诊时间："></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <el-collapse v-if="detailValue.state == '申请中'" value="1">
        <el-collapse-item title="拒绝原因" name="1">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="detailValue.reason"></el-input>
        </el-collapse-item>
      </el-collapse>
    </el-row>
    <template slot="footer">
      <span>
        <el-button @click="$emit('update:visible', false)">关闭</el-button>
      </span>
      <el-button class="left-pad" v-if="detailValue.state == '已接受'" type="primary" @click.native="sumit">完成</el-button>
      <span v-if="detailValue.state == '申请中'" class="left-pad">
        <el-button style="margin" type="warning" @click.native="decision(false)">拒绝</el-button>
        <el-button type="primary" @click.native="decision(true)">接受</el-button>
      </span>
    </template>
  </hic-dialog>
</template>
<script>
import api from "./api";
import { mapGetters } from "sw-hic";
export default {
  components: {},
  props: {
    entity: {
      type: Object,
      default: () => {
        return {};
      },
    },
    detailValue: {
      type: Object,
      default: () => {
        return {};
      },
    },
    visible: Boolean,
    title: String,
  },
  data() {
    return {
      checkedQZ: false,
      checked: false,
      rules: {
        opinions: [
          { required: true, message: '请输入会诊意见', trigger: 'blur' }
        ],
        dept: [
          { required: true, message: '请选择会诊科室', trigger: 'change' }
        ],

        consultationDoctorCode: [
          { required: true, message: '请输入会诊医师', trigger: 'blur' }
        ],
        execDate: [
          { required: true, message: '请选择会诊时间', trigger: 'change' }
        ],
      },
      card: {
        cardType: "ipNo",
        cardNo: "ip0000001", //
      },
      meta: {
        loading: false,
        showOper: false,
        content: false,
        showPayment: false,
      },
      reason: "",
      payParams: {},
    };
  },
  computed: {
    ...mapGetters([
      "dict",
      "getDict",
      "Enum",
      "dictEnum",
      "user",
      "permission",
    ]),
  },
  filters: {},
  watch: {},
  mounted() { },
  methods: {
    decision(state) {
      if (!state && !this.detailValue.reason) {
        this.$message.info('请输入拒绝原因！');
        return;
      }

      // let outPara = { ipNo: this.entity.ipNo, bedNo: this.entity.bedNo, patientCode: this.entity.patientCode, patientName: this.entity.patientName };
      let outPara = { id: this.detailValue.id, state: null, reason: null };
      if (state) {
        outPara.state = this.Enum.ConsultationState.已接受;
      } else {
        outPara.state = this.Enum.ConsultationState.已拒绝;
        outPara.reason = this.detailValue.reason;
      }
      api.Consultation.patch(outPara)
        .then(res => {
          this.$message.success('保存成功');
          this.$emit('update:visible', false);
          this.$emit('ok')
        })
        .catch((err) => {
          this.$message.error(err || err.message);
        })
        .finally((f) => {
        });
    },
    sumit() {
      this.$refs['info'].validate((valid) => {
        if (valid) {
          let outPara = { ipNo: this.entity.ipNo, bedNo: this.entity.bedNo, patientCode: this.entity.patientCode, patientName: this.entity.patientName };
          outPara.state = this.Enum.ConsultationState.已会诊;
          api.Consultation.save({
            ...this.detailValue, ...outPara
          }).then(res => {
            this.$message.success('保存成功');
            this.$emit('update:visible', false);
            this.$emit('ok')
          })
        }
      })
    },



    async queryPatient() {

    },
    lookHistory() {
      this.meta.showOper = true;
    },
    genderFlter(v) {
      let info = this.dict.Gender.find((item) => {
        return v == item.code;
      });
      return "";
    },
    submit(type) {

    },
    addCounts(id) {

    },
    cancel() {
      this.$emit("update:visible", false);
    },
    addFloat(num1, num2) { },
  },
};
</script>
  
<style scoped>
.redaK {
  background-color: #909399;
}

.tx-r {
  text-align: right;
}

.tx-l {
  text-align: left;
}

.tx-c {
  text-align: center;
}

.pall10p {
  padding: 10px;
}

.patientBox {
  height: 5rem;
  margin-bottom: 2rem;
}

.el-row {
  margin-bottom: 10px;
}

.el-row:last-child {
  margin-bottom: 0px;
}

.ztitle {
  margin-top: 10px;
  color: #66b1ff;
}

.inputnw .el-input {
  width: 4rem !important;
}

.inputDelW {
  width: 12rem;
}

.el-form--inline .el-form-item {
  margin-right: 0px;
}
</style>
<style>
.bg {
  background: #cccccc;
  padding: 1.5rem 1rem;
}
</style>
  